module.exports = __webpack_public_path__ + "img/18_73.8d8f03bc.png";